// extracted by mini-css-extract-plugin
export default {"OrderHistoryContainer":"OrderHistoryContainer_OrderHistoryContainer__gfm6P"};